module.exports = __webpack_public_path__ + "static/media/ally-ups-product-img.acd6036d.png";